import React, { useContext } from 'react';

import { RecentTestCyclesContext } from '../RecentTestCyclesProvider';
import { RecentTestCyclesTableView } from './RecentTestCyclesTable.view';

const RecentTestCyclesTable: React.FC = () => {
  const { testCycles, isProjectContext, handleOverviewAction } = useContext(
    RecentTestCyclesContext
  );
  return (
    <RecentTestCyclesTableView
      testCycles={testCycles}
      isProjectContext={isProjectContext}
      handleOverviewAction={handleOverviewAction}
    />
  );
};

export default RecentTestCyclesTable;
